import { Link, makeStyles, Typography } from "@material-ui/core";
import { Formik } from "formik";
import qs from "query-string";
import React from "react";
import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { Link as RouterLink, useHistory } from "react-router-dom";
import * as yup from "yup";
import { SubmitButton, TextField } from "../../components/formik";
import { checkAccessCode } from "../../ducks/actions";
import { useQueryParams } from "../../hooks";
import useNotifications from "../../hooks/useNotifications";

const useStyles = makeStyles(theme => ({
  alignLeft: {
    alignSelf: "flex-start"
  },
  submitButton: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(3)
  }
}));

const AccessCodeForm = () => {
  const intl = useIntl();
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const { ok, ko } = useNotifications();
  const [{ accessCode }] = useQueryParams();

  const validationSchema = yup.object().shape({
    accessCode: yup.string().required()
  });

  const onSubmit = async ({ accessCode }) => {
    const { error } = await dispatch(checkAccessCode({ accessCode }));
    if (error) {
      ko(
        intl.formatMessage({
          id: "Auth.AccessCodeForm.CheckAccessCodeError",
          defaultMessage: "Access code invalid"
        })
      );
    } else {
      ok(
        intl.formatMessage({
          id: "Auth.AccessCodeForm.CheckAccessCodeSuccess",
          defaultMessage: "Access code valid"
        })
      );
      history.push(qs.stringifyUrl({ url: "/register", query: { access_code: accessCode } }));
    }
  };

  return (
    <Formik
      validationSchema={validationSchema}
      validateOnMount
      onSubmit={onSubmit}
      initialValues={{ accessCode }}
    >
      <>
        <Typography variant="h4" className={classes.alignLeft} gutterBottom>
          {intl.formatMessage({
            id: "Auth.AccessCodeForm.EnterAccessCode",
            defaultMessage: "Enter Access Code"
          })}
        </Typography>
        <Typography variant="body1" className={classes.alignLeft}>
          {intl.formatMessage({
            id: "Auth.AccessCodeForm.Helper",
            defaultMessage:
              "To register, you need to enter the access code that was sent to your e-mail."
          })}
        </Typography>

        <TextField
          name="accessCode"
          variant="outlined"
          label={intl.formatMessage({
            id: "Auth.AccessCodeForm.AccessCode",
            defaultMessage: "Access Code"
          })}
          fullWidth
        />
        <SubmitButton
          variant="contained"
          color="primary"
          defaultEnabled
          className={classes.submitButton}
          fullWidth
        >
          {intl.formatMessage({
            id: "Auth.AccessCodeForm.Register",
            defaultMessage: "Register"
          })}
        </SubmitButton>

        <Typography>
          {intl.formatMessage({
            id: "Auth.AccessCodeForm.NeedAccessoCode",
            defaultMessage: "Need an access code?"
          })}
          &nbsp;
          <Link to="/request-code" component={RouterLink}>
            {intl.formatMessage({
              id: "Auth.AccessCodeForm.RequestNow",
              defaultMessage: "Request Now."
            })}
          </Link>
        </Typography>
      </>
    </Formik>
  );
};

export default AccessCodeForm;
